import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import API from "../../../context/API";
import type { RootState } from "../../../redux/store";
import { KIOSK_CONFIG_QUERY_KEY } from "./useKioskConfiguration";
import type { ThemeColors } from "../types";

export const useSaveKioskConfiguration = () => {
  const queryClient = useQueryClient();
  const { role, loginData } = useSelector((state: RootState) => state.auth);

  return useMutation<void, Error, ThemeColors>({
    mutationFn: async (colors) => {
      const body: Record<string, string | null> = { ...colors };
      if (role === "admin" || role === "super_admin") {
        body.merchantId = loginData?.merchantId || loginData?.id;
      }
      await API.post("/kiosk-configuration", body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KIOSK_CONFIG_QUERY_KEY });
    },
  });
};
